import { MultiColumnComboBox } from '@progress/kendo-react-dropdowns';
import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form';
import React, { FunctionComponent } from 'react'
import { TicketApi } from '../../../redux/api/TicketApi';
import {
  Label
} from "@progress/kendo-react-labels";
import { ProjectApi } from '../../../redux/api/ProjectApi';

const SLAList: FunctionComponent<FieldRenderProps> = props => {
  const {
    label,
    id,
    valid,
    disabled,
    optional,
    onChange,
  } = props;

  const { data: config } = TicketApi.useGetSLAConfigQuery();
  const { data: slas, isFetching: fetchingSLAs } = ProjectApi.useGetSLAListQuery({ projectId: props.projectId, priorityId: props.priorityId });
  const { data: selectedSLA } = TicketApi.useGetSLAQuery(props.slaId, { skip: !props.slaId });
  // const SLA = {SLA_ID:props.slaId,SLA_Name:'Nope'} as ISLA;
  const defaultSLA = props.slaId === 0 ? slas?.filter(s => s.SLA_ID === 0) : selectedSLA ? [selectedSLA] : [];


  const bindData = slas?.map(sla => {
    return { ...sla, SLA_Code: sla.SLA_Code || '' }
  });
  const slaColumns = [
    {
      field: "SLA_Name",
      header: "Name",
      width: "300px",
    },
    config?.Multi_SLA_List_Option > 1 ?
      {
        field: "SLA_Code",
        header: "Code",
        width: "100px",
      } : undefined,
    config?.Multi_SLA_List_Option > 2 ?
      {
        field: "SLA_Response_Time",
        header: "Response",
        width: "80px",
      } : undefined,
    config?.Multi_SLA_List_Option > 2 ?
      {
        field: "SLA_Resolve_Time",
        header: "Resolve",
        width: "80px",
      } : undefined
  ].filter(f => f !== undefined);


  return (
    <FieldWrapper>
      {label && <Label
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
        optional={optional}
      >
        {label}
      </Label>}
      <div className={"k-form-field-wrap"}>
        <MultiColumnComboBox className='SLA-list' allowCustom={false} popupSettings={{ className: 'z500' }} filterable={false} value={defaultSLA?.length > 0 ? defaultSLA[0] : null} columns={slaColumns} onChange={onChange} data={bindData} dataItemKey="SLA_ID" textField="SLA_Name" loading={fetchingSLAs} />
      </div>
    </FieldWrapper>

  )
}

export default SLAList